module.exports = __webpack_public_path__ + "img/blue_black.522846e8.jpg";